// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__37Upn","footer":"ChangeClinic_footer__1v2Mh"};